import { INSIGHTS_SORT_DISABLED, INSIGHTS_SORT_ENABLED } from '../actions/insights_sort'

export function insightsSort(state = { sortField: null, order: null }, action) {
  switch (action.type) {
    case INSIGHTS_SORT_ENABLED:
      return { ...state, sortField: action.sortField, order: action.order }
    case INSIGHTS_SORT_DISABLED:
      return { ...state, sortField: null, order: null }
    default:
      return state
  }
}
